import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export var replaceSpaces = function replaceSpaces(value) {
  var valueFormat = value;
  var noBreakSpace = '8239';
  var diaeresis = '168';
  var nonBreakingSpace = '160';
  var _char = String.fromCharCode(noBreakSpace);
  var char2 = String.fromCharCode(diaeresis);
  var char3 = String.fromCharCode(nonBreakingSpace);
  var re = new RegExp(_char, 'g');
  var re2 = new RegExp("" + char2, 'g');
  var re3 = new RegExp("" + char3, 'g');
  valueFormat = _.replace(valueFormat, re, ' ');
  valueFormat = _.replace(valueFormat, re2, ' ');
  valueFormat = _.replace(valueFormat, re3, ' ');
  return valueFormat;
};